<div class="my-24">
  <app-alert
    *ngIf="hasNotStatement"
    class="flex-col-container mb-8 mt-24"
    type="danger"
    icon="error_outline"
    lineHeight="lh-1"
    [message]="'MODAL_STATEMENT_CONTRACT.HAS_NOT_STATEMENTS' | translate"></app-alert>
  <form [formGroup]="form">
    <div class="flex-row-container items-baseline gap-32">
      <app-month-year-field
        class="flex-2"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [label]="'MODAL_STATEMENT_CONTRACT.DATES' | translate"
        formControlName="date"></app-month-year-field>
      <div class="flex-col-container basis-25">
        <button
          mat-flat-button
          color="primary"
          class="w-all"
          [disabled]="form.invalid || form.disabled || isLoading || hasNotStatement"
          (click)="showPreviewOnline()">
          <div class="relative center">
            <div *ngIf="isLoading" class="absolute spinner-position">
              <mat-spinner [diameter]="20" color="primary"></mat-spinner>
            </div>
            {{'MODAL_STATEMENT_CONTRACT.PREVIEW_BUTTON' | translate}}
          </div>
        </button>
      </div>
    </div>
  </form>
</div>
